export default {
  local: 'en',

  role: { //  all belongs to "membership" collection
    member: 'Member', //  can login
    cashier: "Cashier", //  sub-set of npc , used in ecommerce
    npc: 'Non-person character', //  non-person character ( represent admin in membership collections, used in notification and appointment : assign caregiver )
    admin: 'Admin',
    superadmin: 'Super Admin',
  },

  type: {
    login: {
      fb: 'Facebook',
      wechat: 'WeChat',
      emailPwd: 'Email & Password',
    },
    temp_token: {
      forget_password: 'forget_password',
      verifyEmail: 'verifyEmail',
    },
    mediaProfile: {
      png: 'png',
      jpg: 'jpg',
    },
    notification_type: {
      appointment: "appointment",
    },
    notification_sub_type: {
      //  appointment
      new_appointment: "new_appointment",
      new_urgent_appointment: "new_urgent_appointment",
      job_notice_for_caregiver: "job_notice_for_caregiver",

      no_suitable_candidates: "no_suitable_candidates",
      no_caregiver_confirm: "no_caregiver_confirm",
      cancelled_by_client: "cancelled_by_client",
      accepted_by_caregiver: "accepted_by_caregiver",
      cancelled_by_caregiver: "cancelled_by_caregiver",
    },
    transaction: {
      purchase: 'Purchase',
      penalty: 'Penalty',
      refund: 'Refund',
      extra_pay: 'Extra Payment',
      standalone: 'Standalone',
      rapid: 'Rapid Payment',
      caregiver_invoice: '${i18n.schema.caregiver} ${i18n.schema.invoice}',
    },
    coupon: {
      one_time: "One time",   //  each member can only use the coupon once
      unlimited_time: "Unlimited time",   //  ignore expiry day checking
    },
    feedback: {
      admin_to_caregiver: 'Admin to Caregiver',
      admin_to_client: 'Admin to Client',
      client_appointment_feedback: 'Client Appointment Feedback',
      client_to_caregiver: 'Client Appointment Feedback',
      caregiver_appointment_feedback: 'Caregiver Appointment Feedback',
    },
  },

  status: {
    // system: {
    inactive: 'Inactive',
    active: 'Active',
    deleted: 'Deleted', //  by admin
    archived: 'Archived', //  by member
    // },
    // verification: {
    not_verified: 'Not Verified',
    verified: 'Verified',
    // },
    // payment: {
    success: 'Success',
    failed: 'Failed',
    // },
    // commentBox: {
    enabled: 'Enabled',
    disabled: 'Disabled',
    // },
    // appointment_progress_status: {
    waiting_admin_approve: 'Waiting admin approve',
    matching_helper: 'Matching Helper',
    waiting_helper_confirm: "Waiting helper confirm", //  * either assigned by admin or system
    waiting_admin_confirm: 'Waiting admin confirm',
    confirmed: 'Confirmed', //  * caregivers accepted
    in_progress: 'In progress',     //  if not accepted, will not change to in_progress
    waiting_review: 'Waiting review',
    waiting_client_feedback: 'Waiting client feedback',
    waiting_helper_feedback: 'Waiting helper feedback',
    completed: 'Completed',
    incomplete: 'Incomplete', //  will not count as used
    cancelled_by_sender: 'Cancelled by sender',
    // },
    // potential_helper_status: {
    pending: "Pending",
    accepted: "Accepted", //  previous status : pending
    rejected: "Rejected", //  previous status : pending
    cancelled: "Cancelled", //  previous status : accepted
    approved: 'Approved',

    arrived: 'Arrived',
    left: 'Left',
    reported: 'Reported Task',
    feedbacked: 'Feedback Submitted',
    send_invoice: 'Invoice sent',
    invoice_sent: 'Invoice sent',
    complete: 'Completed',
    absent: 'Absent',
    late: 'Late',
  },
  gender: {
    m: 'Male',
    f: 'Female',
  },

  alert: {
    html: {
      cannot_fetch_item_$err: '<span>Cannot fetch item: ${err}</span>',
      cannot_fetch_list_$err: '<span>Cannot fetch list: ${err}</span>',
      $err: '<span>${err}</span>',
      record_updated_successfully: '<span>Record updated successfully</span>',
      record_saved_successfully: '<span>Record saved successfully</span>',
      file_uploaded_successfully: '<span>File uploaded successfully</span>',
      no_subprofile: 'Missing service user',
      no_subprofile_desc: 'The member does not have any service user. Please create one first.',
      confirm_force_assign_job_to_this_member: 'Are you sure to assign this member?',
      confirm_force_assign_job_to_this_member_ignore_accepted: 'Do you till want to force assign this member?<br/>Someone has already accepted.',
      time_clash_$appointments: 'Cooldown time clash detected for this caregiver:<br/><ul>${appointments.map(function(x){return "<li>" + x + "</li>"})}</ul><br/>Still assign?',
      not_available_days_$days: 'Caregiver is not available at the time:<br/><ul>${days.map(function(x){return "<li>" + x + "</li>"})}</ul><br/>Still assign?',
      confirm_delete_$str: 'Confirm delete ${str}?',
      confirm_action_$action: 'Confirm ${action}?',
      update_linked_subprofile: `
This will update the \${i18n.schema.subprofile} of:<br/>
<ul>
    <li>the current \${i18n.schema.appointment}</li>
    <li>\${i18n.schema.subprofile} for future created \${i18n.schema.appointments}</li>
    <li>\${i18n.schema.subprofile} for future created \${i18n.schema.orders}</li>
</ul><br/>
Confirm?`,
      update_subprofile: 'This will update the ${i18n.schema.subprofile} of the current ${i18n.schema.appointment}<br/>Confirm?',
      confirm_complete_invoice: 'Confirm marking invoice completed?',
      warn_modify_status: '<span style="color: red">Changing status manually may affect normal system workflow, not recommended.</span>',
    },
    empty_response: 'Empty response',
    invalid_response: 'Invalid response from server',
    please_choose_an_item_by_clicking_a_row: 'Please click on a row to choose an item.',
    force_assign_job_add_only: 'Do you want to assign the caregiver now or only add to pending list?\n\n[OK]: Assign, [Cancel]: Add only.',
  },
  html: {
    nil: '<small style="opacity: .5;"><i>&lt;nil&gt;</i></small>',
    loading: '<i>${i18n.loading}</i>',
    not_found: '<i>Not Found</i>',
    empty: '<i>&lt;empty&gt;</i>',
  },
  loading: 'Loading...',
  updated_at_$time: 'Updated at ${time}',
  application_title: 'OK CARE Admin Panel',
  nil: '<nil>',
  label_compulsory: '(compulsory)',
  label_pick_a_month: 'Pick a month',
  label_pick_a_profession: 'Pick a Profession',
  create_schema_$name: 'Create New ${name}',
  update_schema_$name: 'Update ${name}',
  schema_$name_details: '${name} Details',
  admin: 'Admin',
  ecommerce: 'E-Commerce',
  pagination_footer: 'Showing ${from} to ${to} of ${total} entries',
  search_placeholder: 'Search...',
  search_records_placeholder: 'Search records',
  disk_usage: 'Disk Usage',
  ram_usage: 'RAM Usage',
  cpu_usage: 'CPU Usage',
  revenue: 'Revenue',
  revenue_$income_$refund: 'income: $${income}, refund: $${refund}',
  cancelled_by_caregiver: '${i18n.schema.appointments} cancelled by ${i18n.schema.caregiver}',
  complaint: 'Complaint',
  complaints: 'Complaints',
  not_interviewed: 'Not interviewed',
  appointment_requests_$total_$urgent: '${total} ${urgent ? "(" + urgent + " urgent)" : ""}',
  pending_invoices: 'Pending Invoices',
  no_name: 'No Name',
  menu: {
    overview: 'Overview',
    members: 'Memberships',
    appointments: 'Booking Management',
    ecommerce: 'Order Management',
    admin: 'Administration',
    feedbacks: 'Rating Management',
    notifications: 'Notification',
    systemconfigs: 'System Configuration',
    reports: 'Reporting',
  },
  schema: {
    member: 'Membership',
    members: 'Memberships',
    admin: 'Administrator',
    admins: 'Administrators',
    caregiver: 'Caregiver',
    caregivers: 'Caregivers',
    client: 'Client',
    clients: 'Clients',
    subprofile: 'Service User',
    subprofiles: 'Service Users',
    linked_subprofiles: 'Linked Service Users for future use',
    group: 'Profession',
    groups: 'Professions',
    group_application: 'Profession Application',
    group_applications: 'Profession Applications',
    group_apply: 'Apply Profession',
    appointment: 'Booking',
    appointments: 'Bookings',
    appointment_request: 'Booking Request',
    appointment_requests: 'Booking Requests',
    order: 'Order',
    orders: 'Orders',
    transaction: 'Transaction',
    transactions: 'Transactions',
    invoice: 'Invoice',
    invoices: 'Invoices',
    standalone_transaction: 'Standalone Transaction',
    rapid_payment: 'Rapid Payment',
    refund_transaction: 'Refund',
    payment: 'Payment',
    payments: 'Payments',
    product: 'Product',
    products: 'Products',
    service: 'Service',
    services: 'Services',
    coupon: 'Coupon',
    coupons: 'Coupons',
    feedback: 'Feedback',
    feedbacks_admin: 'Feedbacks (Admin)',
    feedbacks_admin_caregiver: '${i18n.type.feedback.admin_to_caregiver}',
    feedbacks_admin_client: '${i18n.type.feedback.admin_to_client}',
    feedbacks_caregiver: 'Feedbacks (Care Giver)',
    feedbacks_client: 'Feedbacks (Client)',
    feedback_admin: 'Feedback (Admin)',
    feedback_caregiver: 'Feedback (Care Giver)',
    feedback_client: 'Feedback (Client)',
    notification: 'Notification',
    notifications: 'Notifications',
    systemnotification: 'System Notification',
    systemnotifications: 'System Notifications',
    adminsendout: 'Admin Send-out',
    adminsendouts: 'Admin Send-outs',
    email: 'Email',
    emails: 'Emails',
    systemconfig: 'System Config',
    systemconfigs: 'System Configs',
    enquiry: 'Enquiry',
    enquiries: 'Enquiries',
    enquiry_questionnaire: 'Questionnaire',
    enquiry_questionnaires: 'Questionnaires',
    log: 'Log',
    logs: 'Logs',
    content: 'Content',
    contents: 'Content Management',
    'content-joinus-input_form': 'Join Us (input form)',
    'content-area-content': 'Area Content',
    'content-purchase-latest_booking': 'Purchase (latest booking)',
    'content-purchase-new_order': 'Purchase (new order)',
    'content-joinus-banner_top': 'Join Us (banner top)',
    'content-our_services_page-whyus_features': 'Our Services (why us - features section)',
    'content-our_services_page-overlabel': 'Our Services (over-label)',
    'content-our_services_page-banner_bottom': 'Our Services (banner bottom)',
    'content-our_services_page-download_top': 'Our Services (download top)',
    'content-our_services_page-whyus_middle': 'Our Services (why us - middle section)',
    'content-our_services_page-our_services_details': 'Our Services (details)',
    'content-content-faq': 'Faq',
    'content-aboutus-tri': 'About Us (tri)',
    'content-aboutus-bridge': 'About Us (bridge)',
    'content-aboutus-middle': 'About Us (middle)',
    'content-aboutus-plain_text': 'About Us (plain text)',
    'content-recruitment': 'Recruitment',
    post: 'Post',
    posts: 'Posts',
  },
  fields: {
    display_name_$first_$last: '${first} ${last}',
    years_old_$yrs: '${yrs} years old',
    array_item_$i: '# ${i}',
    cat: {
      default: 'misc.',
      general: 'General',
      client: '${i18n.schema.client}',
      caregiver: '${i18n.schema.caregiver}',
      subprofile: '${i18n.schema.subprofile}',
    },
    currency: {
      cash_hkd: 'HKD',
      cash_rmb: 'RMB',
      cash_usd: 'USD',
    },
    medical_histories: {
      disease: {
        heart_disease: 'Heart Disease',
        cancer: 'Cancer',
        hypertension: 'Hypertension',
        stroke: 'Stroke',
        diabetes: 'Diabetes',
        genetic_disease: 'Genetic Disease',
      },
      currentStatus: {
        stomach_throat: 'Stomach Throat',
        urinary_throat: 'Urinary Throat',
        bed_sores: 'Bed Sores',
        need_an_injection: 'Need an injection',
        wounds_after_surgery: 'Wounds after surgery',
      },
    },
    content_types: {
      appointment: '${i18n.schema.appointment}',
      membership: '${i18n.schema.member}',
      ecommerce: 'E-Commerce',
      system: 'System',
    },
    service_areas: {
      hki: 'Hong Kong Island',
      kl: 'Kowloon',
      nt: 'New Territories',
      isl: 'Islands',
    },
    roles: {
      member: 'Member',
      admin: 'Admin',
      superadmin: 'Super Admin',
    },
    init_login_types: {
      emailPwd: '${i18n.fields.email}',
      sms: '${i18n.fields.phone}',
    },
    id: 'ID',
    member_id: '${i18n.schema.member} ${i18n.fields.id}',
    subprofile_id: '${i18n.schema.subprofile} ${i18n.fields.id}',
    subprofile: '${i18n.schema.subprofile}',
    subProfile: '${i18n.schema.subprofile}',
    subprofiles: '${i18n.schema.subprofiles}',
    subProfiles: '${i18n.schema.subprofiles}',
    group_id: '${i18n.schema.group} ${i18n.fields.id}',
    group: '${i18n.schema.group}',
    groups: 'Qualified tasks',
    service_id: '${i18n.schema.service} ${i18n.fields.id}',
    appointment_id: '${i18n.schema.appointment} ${i18n.fields.id}',
    appointment: '${i18n.schema.appointment}',
    appointments: '${i18n.schema.appointments}',
    order_id: '${i18n.schema.order} ${i18n.fields.id}',
    order: '${i18n.schema.order}',
    orders: '${i18n.schema.orders}',
    feedback_id: '${i18n.schema.feedback} ${i18n.fields.id}',
    content_id: '${i18n.schema.content} ${i18n.fields.id}',
    coupon_id: '${i18n.schema.coupon} ${i18n.fields.id}',
    coupon_code: '${i18n.schema.coupon} Code (Case sensitive)',
    notification_id: '${i18n.schema.notification} ${i18n.fields.id}',
    transaction_id: '${i18n.schema.transaction} ${i18n.fields.id}',
    transaction: '${i18n.schema.transaction}',
    transactions: '${i18n.schema.transactions}',
    product_id: '${i18n.schema.product} ${i18n.fields.id}',
    product: '${i18n.schema.product}',
    products: '${i18n.schema.products}',
    payment_id: '${i18n.schema.payment} ${i18n.fields.id}',
    payment: '${i18n.schema.payment}',
    payments: '${i18n.schema.payments}',
    email: 'Email',
    phone: 'Mobile no.',
    phone_placeholder: 'Please include country code, i.e.: 852xxxxxxxx',
    pwd: 'Password',
    role: 'Role',
    timeslot: 'Time slot',
    feature: 'Feature',
    created_at: 'Created at',
    updated_at: 'Updated at',
    expired_at: 'Expired at',
    status: 'Status',
    self_status: 'Status',
    tags: 'Tags',
    type: 'Type',
    basicInfo_fulfilled: 'Basic info fulfilled',
    email_fulfilled: 'Email fulfilled',
    init_login_type: 'Initial login type',
    details: 'Details',
    verification: 'Verification',
    activation_code: 'Activation code',
    apply_group: 'Apply ${i18n.schema.group}',
    finished_interview: 'Finished interview',
    add_subprofile: '${i18n.action.add} ${i18n.schema.subprofile}',
    my_subprofiles: 'My ${i18n.schema.subprofiles}',
    my_appointments: 'My ${i18n.schema.appointments}',
    my_jobs: 'My Jobs',
    my_orders: 'My ${i18n.schema.orders}',
    subprofiles_count: '# of ${i18n.schema.subprofiles}',
    pending_group: '${i18n.schema.group}',
    pending_status: 'Status',
    remark: 'Remark',
    order_remarks: '${i18n.schema.order} ${i18n.fields.remark}',
    score: 'Score',
    scores: 'Scores',
    question: 'Question',
    avg_score: 'Avg. Score',
    action: ' Action',
    sender: 'Sender',
    receiver: 'Receiver',
    recipient: 'Recipient',
    refs_appointment: 'Reference ${i18n.schema.appointment}',
    profile: 'Profile',
    relationship: 'Relationship',
    service_location: 'Service Location',
    user_experience: 'User Experience',
    emergency_contact: 'Emergency Contact',
    user_condition: 'User Condition',
    medical_history: 'Medical History',
    stat: 'Statistics',
    view: 'Views',
    click: 'Clicks',
    creator: 'Creator',
    created_by: '${i18n.fields.creator}',
    first_name: 'First Name',
    last_name: 'Last Name',
    other_name: 'Other Names',
    gender: 'Gender',
    hkid: 'HKID',
    mobile: 'Mobile no.',
    home_tel: 'Home no.',
    age: 'Age',
    birthday: 'Date of Birth',
    height: 'Height (m)',
    weight: 'Weight (kg)',
    ratio: 'Ratio',
    name: 'Name',
    room: 'Room',
    flat: 'Flat',
    floor: 'Floor',
    block: 'Block',
    building: 'Building',
    street: 'Street',
    area: 'Area',
    district: 'District',
    detail: '${i18n.fields.details}',
    required_groups: 'Required ${i18n.schema.groups}',
    product_ids: '${i18n.schema.products}',
    value_options: 'Value Options',
    quota: 'Quota',
    quota_per_user: 'Quota per user',
    currency_type: 'Currency type',
    currency_amount: 'Currency amount',
    used_by: 'Usage history',
    used_at: 'Used at',
    member: '${i18n.schema.member}',
    read: 'Read',
    content_type: 'Content type',
    content: 'Content',
    title: 'Title',
    code: 'Code',
    sub_type: 'Sub type',
    admin: 'Is Admin?',
    expiry_date: '${i18n.fields.expired_at}',
    from: 'From',
    to: 'To',
    tickets: 'Tickets',
    total_tickets: 'Total ${i18n.fields.tickets}',
    available_tickets: 'Available ${i18n.fields.tickets}',
    progress_status: 'Progress Status',
    service_date: 'Service Date',
    language: 'Language',
    notification: 'Notification',
    sms: 'SMS',
    app_config: 'User Preference',
    address: 'Address',
    custom: 'Special Item',
    customs: 'Special Items',
    custom_id: '${i18n.fields.id}',
    custom_ids: '${i18n.fields.customs}',
    required_custom_types: 'Compulsory Items',
    timeslots: 'Service Timeslots',
    owners: 'Owners',
    value: 'Value',
    description: 'Description',
    price_options: 'Price Options',
    inventory: 'Inventory',
    inventory_unlimited: 'Unlimited Inventory',
    privacy: 'Permission Level',
    days_to_expiry: 'Days to expiry',
    reason: 'Reason',
    photo: 'Photo',
    transaction_code: 'Payment Code',
    ref: 'References',
    total_amount: 'Total Amount',
    refund_amount: 'Refund Amount (should be negative)',
    expected_start_date: 'Expected start date',
    quantity: 'Quantity',
    order_remark: 'Remarks',
    log_write_requests: 'Log requests with write operations',
    caregiver_report: '${i18n.schema.caregiver} Report',
    potential_recipients: 'Potential ${i18n.schema.caregivers}',
    potential_recipient_status: '${i18n.schema.caregiver} ${i18n.fields.status}',
    potential_recipients_count: '# of ${i18n.schema.caregiver}',
    show_cancelled_recipients: 'Show cancelled ${i18n.schema.caregivers}',
    transaction_progress: 'Transaction Progress',
    list_order: 'List Order',
    notes: 'Notes',
    working_history: 'Working History',
    working_experience: 'Working Experience',
    certificates: 'Certificates',
    marriage_status: 'Marriage Status',
    bank_account: 'Bank Account',
    bank_type: 'Bank',
    referral: 'Referral',
    signed_contract: 'Has signed contract',
    working_visa: 'Has issued working Visa',
    company: 'Company',
    startDate: 'Start',
    endDate: 'End',
    fulltime: 'Full-time',
    issuer: 'Issuer',
    promotion: 'Receive Promotion',
    is_promotion: 'Is Promotional?',
    profile_pic: 'Profile Pic',
    unit_amount: 'Unit Amount',
    location_fee: 'Location Fee',
    records: 'Records',
    reset_password: 'Reset password',
    new_password: 'New password',
    confirm_password: 'Confirm password',
    payment_gateway_err: '3rd party payment gateway error',
    editable: 'Editable',
    years_of_experience: 'Years of Experience',
    receivers: 'Receivers',
    ticket_required: 'Ticket Required',
    invoice_completed: 'Invoice Paid',
  },
  action: {
    ok: 'OK',
    yes: 'Yes',
    no: 'No',
    cancel: 'Cancel',
    save: 'Save',
    create: 'Create',
    duplicate: 'Duplicate',
    add: 'Add',
    back: 'Back',
    update: 'Update',
    upload: 'Upload',
    upload_replace: 'Upload and Replace',
    reload: 'Refresh',
    undo: 'Undo',
    download: 'Download',
    assign_job_to_this_member: 'Assign job to this ${i18n.schema.caregiver}',
    force_assign_job_to_this_member: 'Force assign job to this ${i18n.schema.caregiver}',
    force_assign_job: 'Manually assign ${i18n.schema.caregiver}',
    create_$obj: 'Create ${obj}',
    add_new_$obj: 'Add New ${obj}',
    export_data: 'Export Data',
    export_$obj: 'Export ${obj}',
    complete_appointment: 'Complete ${i18n.schema.appointment}',
    show_inactive: 'Show inactive',
    send_feedback_to_caregiver: 'Feedback to ${i18n.schema.caregiver}',
    send_feedback_to_client: 'Feedback to ${i18n.schema.client}',
    approve: 'Approve',
    reject: 'Reject',
    login: 'Login',
    logout: 'Logout',
    read: 'Mark as Read',
    unread: 'Mark as Unread',
    delete: 'Delete',
    clear_tokens: 'Clear Login Sessions',
    apply: 'Apply',
    click_to_$action: 'Click to ${action}',
    finished_interview: '${i18n.fields.finished_interview}',
    distribute_job: 'Re-distribute Job',
    choose_$obj: 'Choose ${obj} ...',
    reformat_code: 'Reformat',
    view_invoice: 'View ${i18n.schema.invoice}',
    complete_invoice: 'Complete ${i18n.schema.invoice}',
    import_members: 'Import ${i18n.schema.members}',
    update_stat: 'Update Statistics',
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en.js